import { render, staticRenderFns } from "./SurchargeDuplicateForm.vue?vue&type=template&id=d17c1f20&"
import script from "./SurchargeDuplicateForm.vue?vue&type=script&lang=js&"
export * from "./SurchargeDuplicateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports